import React from 'react';
import { CaseStudyDetail } from '../components/CaseStudyDetail';
import { FeatureVideo } from '../components/FeatureVideo';
import { caseStudies } from '../data/caseStudies';
import { mckinseyImages, mckinseyIntro, mckinseyMetrics, mckinseySections } from '../data/mckinseyCaseStudy';
type McKinseyCaseStudyProps = {
  heroMedia?: 'video' | 'carousel';
};
export function McKinseyCaseStudy({
  heroMedia = 'video'
}: McKinseyCaseStudyProps) {
  const card = caseStudies.find(s => s.id === 'mckinsey');
  const videoSrc = card?.videos?.[0];
  const media = heroMedia === 'video' && videoSrc && card ? <FeatureVideo src={videoSrc} poster={card.images[0]} background={mckinseyIntro.background} label="Aon sales and revenue dashboard walkthrough" data-id="element-179" data-mp="1grqdwx7zzdm9" /> : undefined;
  return <CaseStudyDetail id="mckinsey" intro={mckinseyIntro} images={mckinseyImages} metrics={mckinseyMetrics} sections={mckinseySections} media={media} data-id="element-180" data-mp="5f7f9ivjtcg4" />;
}